import clsx from 'clsx'
import React from 'react'
import { useSelector } from 'react-redux'

import ToastCheck from '../../assets/imgs/toast-check.svg'

import './WsnToast.scss'

const WsnToast = ({ heading, message, url }) => {
   const { isDarkTheme } = useSelector(state => state.theme)

   return (
      <div className={clsx('WsnToast', isDarkTheme && 'WsnToast--dark')}>
         <img width="24px" height="24px" src={ToastCheck} alt="Success" />
         <div className="WsnToast__body">
            <h3 className="WsnToast__heading">{heading}</h3>
            <p className="WsnToast__message">{message}</p>
            {!!url && (
               <a
                  className="WsnToast__link"
                  href={url}
                  target="_blank"
                  rel="noreferrer"
                  noopener
               >
                  View on BscScan
               </a>
            )}
         </div>
      </div>
   )
}

export default WsnToast
